export default __webpack_public_path__ + "static/media/F0003.256a4d3a.png";